import type { ReactNode } from "react";
import { cx } from "@/shared/lib/cx";
import { IconChip, type IconName } from "../Icon";

export function Card({ title, subtitle, icon, actions, children, footer, flush, sticky, className, id }: {
  title?: ReactNode; subtitle?: ReactNode;
  /** Glyph shown before the title. */
  icon?: IconName;
  actions?: ReactNode; children: ReactNode; footer?: ReactNode;
  /** No body padding (tables, lists that draw their own rows). */
  flush?: boolean;
  /** Stick to the top while the page scrolls (side panels, previews). */
  sticky?: boolean;
  className?: string; id?: string;
}) {
  return (
    <section id={id} className={cx("card", flush && "card-flush", sticky && "card-sticky", className)}>
      {(title || actions) && (
        <header className="card-header">
          <div className="card-header-text">
            {icon && <IconChip name={icon} size="sm" />}
            <div className="stack">
              {title && <h2 className="card-title">{title}</h2>}
              {subtitle && <p className="card-subtitle">{subtitle}</p>}
            </div>
          </div>
          {actions && <div className="card-actions">{actions}</div>}
        </header>
      )}
      <div className="card-body">{children}</div>
      {footer && <footer className="card-footer">{footer}</footer>}
    </section>
  );
}
